import { Action, State, types } from '.';
// import MasterData from '../../../models/masterData';

const initialState: State = {
    loading: false,
    specialties: []
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.ACTION_SERVER_DATA_REQUESTED:
            return {
                ...state,
                loading: true
            };

        case types.ACTION_SERVER_DATA_FAILED:
            return {
                ...state,
                loading: false
            };
        
        case types.GET_ALL_SPECIALTIES_SUCCEEDED: {
            return {
                ...state,
                loading: false,
                specialties: action.specialties
            };
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/masterData/reducer.ts